<template>
  <div class="container">
    <Header></Header>
    <headerSearch></headerSearch>
    <mainTab></mainTab>
    <div class="find_product_detail">
      <div class="wrap1">
        <div class="fs18 flex-box mb40">
          <div class="col90">当前位置：</div>
          <router-link class="col04" to="/activities">活动<span class="plr5"> / </span>万件拼团<span class="plr5"> / </span></router-link>
          <div class="col04">婕尔MAX玻尿酸</div>
        </div>
        <!-- 商品 -->
        <div class="product_wrap flex-box flex-col-start">
          <!-- 大图 -->
          <div class="img_box">
            <img src="@/assets/static/images/z_img_product1.png" class="img1" />
            <div class="img_tip1 flex-box flex-center flex-col-baseline">
              <div class="text1 fs24">距结束还有</div>
              <div class="time">05</div>
              <div class="text1 fs24">天</div>
              <div class="time">18</div>
              <div class="text1 fs24">时</div>
              <div class="time">22</div>
              <div class="text1 fs24">分</div>
              <div class="time">16</div>
              <div class="text1 fs24">秒</div>
            </div>
          </div>
          <!-- 小图 -->
          <div class="img_col">
            <div class="mini_img_box active">
              <img src="@/assets/static/images/z_img_product1.png" class="mini_img" />
            </div>
            <div class="mini_img_box">
              <img src="@/assets/static/images/z_img_product1.png" class="mini_img" />
            </div>
            <div class="mini_img_box">
              <img src="@/assets/static/images/z_img_product1.png" class="mini_img" />
            </div>
            <div class="mini_img_box">
              <img src="@/assets/static/images/z_img_product1.png" class="mini_img" />
            </div>
            <div class="mini_img_box">
              <img src="@/assets/static/images/z_img_product1.png" class="mini_img" />
            </div>
            <div class="mini_img_box">
              <img src="@/assets/static/images/z_img_product1.png" class="mini_img" />
            </div>
          </div>
          <!-- 商品信息 -->
          <div class="flex-grow-1">
            <div class="product_name fs24">
              婕尔MAX玻尿酸婕尔MAX玻尿酸婕尔MAX玻尿酸婕尔MAX玻尿酸 <span class="name_label fs16">正品保证</span>
            </div>

            <div class="product_label flex-box flex-wrap">
              <div class="item fs18">正品保证</div>
              <div class="item fs18">10盒起购</div>
              <div class="item fs18">限购100件</div>
            </div>
            <div class="flex-box mb20">
              <img src="@/assets/static/icon/z_icon_miao.png" class="icon_miao" />
              <div class="product_price">
                <span class="price1 fs24">¥</span>
                <span class="price2 fs34">199</span>
                <span class="price1 fs28">/盒</span>
              </div>
              <div class="old_price fs18">原价：¥168</div>
            </div>

            <div class="product_info fs18">
              <div class="">规格：100ml/盒</div>
              <div class="">规格/参数:</div>
              <div class="">批准文号: 国药准字H20000708</div>
              <div class="">有效期：2024年6月17日</div>
              <div class="">厂家：上海高实集团</div>
            </div>

            <div class="flex-box mb40">
              <div class="fs20 zcol27 mr15">数量</div>
              <div class="count_box flex-box">
                <div class="action action1"></div>
                <div class="num fs24">100</div>
                <div class="action action2"></div>
              </div>
              <div class="inventory fs20 flex-grow-1">库存：10086</div>
              <div class="flex-box btn_coll zpointer fs20">
                <img src="@/assets/static/icon/z_icon_collect.png" />
                <div>收藏</div>
              </div>
            </div>

            <div class="flex-box">
              <div class="btn_buy fs20">立即预约</div>
            </div>
          </div>
        </div>
      </div>

      <!-- tab -->
      <div class="product_tabs flex-box flex-end">
        <div class="item fs20" :class="{ active: tabIdx == 1 }" @click="tabClick(1)">基本参数</div>
        <div class="item fs20" :class="{ active: tabIdx == 2 }" @click="tabClick(2)">详情信息</div>
        <div class="item fs20" :class="{ active: tabIdx == 3 }" @click="tabClick(3)">注意事项</div>
      </div>

      <div class="wrap2 flex-box flex-col-start">
        <!-- 热销榜 -->
        <div class="hot_list">
          <div class="title flex-box flex-center fs20">
            <img src="@/assets/static/icon/z_icon_hot.png" />
            <div>热销榜</div>
          </div>
          <!--  -->
          <router-link class="" to="" v-for="(item, index) in 3" :key="index">
            <div class="hot_item flex-box">
              <img src="@/assets/static/images/z_img_product1.png" class="img1" />
              <div class="flex-grow-1">
                <div class="flex-box flex-col-baseline">
                  <div class="price_num fs20">¥ 59～199</div>
                  <div class="price_unit fs16">/盒</div>
                </div>
                <div class="name fs20">婕尔MAX玻尿酸</div>
                <div class="spec fs16">
                  <div>规格：100ml/盒</div>
                  <div>效期：2024年6月17日</div>
                  <div>厂家：上海高实集团</div>
                </div>
              </div>
            </div>
          </router-link>
          <!--  -->
          <router-link class="" to="">
            <div class="flex-box flex-center link_more fs16">
              <div>查看更多</div>
              <img src="@/assets/static/icon/z_icon_more.png" class="icon_more" />
            </div>
          </router-link>
        </div>
        <!-- tab详情区 -->
        <div class="flex-grow-1 tab_block">
          <!-- 基本参数 -->
          <div class="block1 fs18" v-if="tabIdx == 1">
            <div class="spec_row flex-box">
              <div class="key">通用名称</div>
              <div class="flex-grow-1 value">通用名称通用名称通用名称</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">商品名称</div>
              <div class="flex-grow-1 value">商品名称商品名称商品名称</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">批准文号</div>
              <div class="flex-grow-1 value">食健备G123456789012</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">规格</div>
              <div class="flex-grow-1 value">100毫升×2支</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">生产企业</div>
              <div class="flex-grow-1 value">上海高实医疗科技集团有限公司</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">生产企业地址</div>
              <div class="flex-grow-1 value">上海市闵行区合川路3136号8幢东侧5楼B区</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">产品分类</div>
              <div class="flex-grow-1 value">产品分类类目</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">生产日期</div>
              <div class="flex-grow-1 value">2024年6月17日</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">截止日期</div>
              <div class="flex-grow-1 value">2027年6月17日</div>
            </div>
            <div class="spec_row flex-box">
              <div class="key">注册证号</div>
              <div class="flex-grow-1 value">123A456B789C012D34</div>
            </div>
          </div>
          <!-- 详情信息 -->
          <div class="block2" v-if="tabIdx == 2">
            <!-- <img src="@/assets/static/images/z_img_detail.png" class="img_detail" /> -->
          </div>
          <!-- 注意事项 -->
          <div class="block3 fs20" v-if="tabIdx == 3">
            <div class="note">
              注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项
            </div>
            <div class="note">
              注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项
            </div>
            <div class="note">
              注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项注意事项
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ForecastDetail",
  setup() {},
  data() {
    return {
      tabIdx: 1,
    };
  },
  created() {},
  methods: {
    tabClick(i) {
      this.tabIdx = i;
    },
  },
};
</script>
<style lang="less" scoped>
.find_product_detail {
  // width: 1920px;
}
.wrap1 {
  padding: 35px 230px 68px 260px;
  background-color: #fff;
}
.product_wrap {
  .img_box {
    position: relative;
    margin-right: 35px;
    width: 580px;
    height: 580px;
    border-radius: 8px;
    background: rgba(150, 150, 150, 0.06);
    border: 1px solid rgba(98, 134, 171, 0.2);
    .img1 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      max-width: 412px;
    }
  }

  .img_col {
    margin-right: 60px;
    height: 580px;
    overflow-y: scroll;
    .mini_img_box {
      position: relative;
      width: 108px;
      height: 108px;
      border-radius: 8px;
      background: #ffffff rgba(150, 150, 150, 0.06);
      border: 1px solid rgba(98, 134, 171, 0.2);
      cursor: pointer;
      .mini_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        max-width: 92px;
      }
    }
    .mini_img_box + .mini_img_box {
      margin-top: 10px;
    }
    .mini_img_box.active {
      background-color: #fff;
      border: 2px solid #3d7efe;
    }
  }

  .product_name {
    padding: 6px 0 28px;
    line-height: 38px;
    color: #272727;
    letter-spacing: 1px;
    .name_label {
      vertical-align: 2px;
      margin-left: 10px;
      display: inline-block;
      padding: 0 10px;
      height: 26px;
      border-radius: 65px;
      background: linear-gradient(117deg, #4ac3fc 0%, #3d6cfe 100%);
      color: #fff;
      line-height: 26px;
      font-weight: bold;
    }
  }
  .product_label {
    .item {
      margin: 0 12px 14px 0;
      padding: 0 7px;
      height: 31px;
      border: 2px solid #eb3f25;
      color: #eb3f25;
      line-height: 29px;
      font-weight: 500;
      border-radius: 4px;
    }
  }
  .product_price {
    font-weight: 500;
    .price1 {
      color: #eb3f25;
      line-height: 33px;
    }
    .price2 {
      font-weight: bold;
      color: #eb3f25;
      line-height: 48px;
    }
  }
  .old_price {
    margin-top: 8px;
    margin-left: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #cacaca;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    text-decoration: line-through;
  }
  .product_info {
    margin: 0 0 30px;
    color: #969696;
    line-height: 36px;
  }
  .count_box {
    margin-right: 35px;
    .action {
      position: relative;
      width: 45px;
      height: 40px;
      border: 1px solid #e0e7ee;
      background: #f9f9f9;
      cursor: pointer;
    }
    .action1 {
      border-radius: 10px 0 0 10px;
      border-right: 0;
    }
    .action2 {
      border-radius: 0 10px 10px 0;
      border-left: 0;
    }
    .action::before {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      width: 16px;
      height: 2px;
      background: #969696;
    }
    .action2::after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      height: 16px;
      width: 2px;
      background: #969696;
    }
    .num {
      padding: 0 5px;
      min-width: 70px;
      height: 40px;
      border: 2px solid #3d7efe;
      text-align: center;
      line-height: 36px;
      background: #f9f9f9;
      color: #272727;
      font-weight: 400;
    }
  }

  .inventory {
    color: #1275ff;
    font-weight: 400;
    line-height: 45px;
  }
  .btn_coll {
    color: #272727;
    font-weight: 400;
    text-align: center;
    img {
      margin-right: 14px;
      display: block;
      width: 29px;
      height: 29px;
    }
  }
  .btn_cart {
    width: 307px;
    height: 60px;
    border-radius: 10px;
    border: 1px solid #d2d2d2;
    color: #1275ff;
    font-family: PingFangSC;
    font-weight: bold;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    font-size: 20px;
  }
  .btn_buy {
    width: 307px;
    height: 60px;
    border-radius: 10px;
    background: #1275ff;
    color: #ffffff;
    font-family: PingFangSC;
    font-weight: bold;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    font-size: 20px;
  }
  .btn_cart + .btn_buy {
    margin-left: 30px;
  }
}
.product_tabs {
  // padding: 0 0 0 874px;
  // width: 1920px;
  height: 76px;
  background: rgba(61, 126, 254, 0.04);
  .item {
    width: 250px;
    height: 76px;
    color: #040404;
    font-family: PingFangSC;
    font-weight: 400;
    line-height: 76px;
    cursor: pointer;
    text-align: center;
  }
  .item.active {
    position: relative;
    background: rgba(255, 255, 255, 0.8);
  }
  .item.active::before {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    content: "";
    width: 80px;
    height: 4px;
    background: #1275ff;
  }
}
.wrap2 {
  padding: 0 230px 60px 260px;
}
.hot_list {
  margin-right: 134px;
  padding: 42px 0 0;
  width: 480px;
  .link_more {
    .icon_more {
      margin-left: 14px;
      display: block;
      width: 14px;
      height: 14px;
    }
    color: #969696;
    font-family: PingFangSC;
    font-weight: 400;
    text-decoration: underline;
  }
  .title {
    margin: 0 0 40px;
    color: #1275ff;
    font-weight: bold;
    img {
      margin-right: 12px;
      display: block;
      width: 29px;
      height: 34px;
    }
  }
  .hot_item {
    padding: 19px 30px 13px 42px;
    margin: 0 0 24px;
    width: 480px;
    border-radius: 8px;
    background: #f5f8fe;
    .img1 {
      margin-right: 50px;
      display: block;
      width: 154px;
      height: 154px;
      border-radius: 8px;
      background: #ffffff;
    }
    .price_num {
      color: #eb3f25;
      font-family: OPPOSans;
      font-weight: 500;
      line-height: 31px;
    }
    .price_unit {
      color: #eb3f25;
      font-family: PingFangSC;
      font-weight: 500;
    }
    .name {
      margin: 5px 0 0;
      color: #272727;
      font-family: OPPOSans;
      font-weight: bold;
    }
    .spec {
      margin: 8px 0 0;
      color: #969696;
      font-family: OPPOSans;
      font-weight: 400;
      line-height: 27px;
    }
  }
}
.tab_block {
  .block3 {
    .note {
      position: relative;
      margin: 0 0 20px;
      padding-left: 38px;
      color: #c9cdd4;
      font-family: PingFangSC;
      font-weight: 400;
    }
    .note::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      background: #1275ff;
      border-radius: 50%;
    }
    padding: 45px 0 0;
  }
  .block2 {
    padding: 45px 0 0;
    .img_detail {
      display: block;
      width: 100%;
    }
  }
  .block1 {
    padding: 85px 0 0;
    .spec_row {
      padding: 22px 0;
      font-family: PingFangSC;
      font-weight: 400;
      border-bottom: 1px solid rgba(98, 134, 171, 0.6);
      .value {
        color: #272727;
      }
      .key {
        width: 268px;
        color: #969696;
      }
    }
  }
}

// 新
.product_wrap {
  .img_tip1 {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 579px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #3d7efe 100%);
    border-radius: 7px;
    padding: 67px 24px 28px;
    .text1 {
      font-weight: 500;
      color: #ffffff;
      line-height: 34px;
      letter-spacing: 1px;
      font-style: normal;
    }
    .time {
      margin: 0 12px;
      width: 28px;
      height: 27px;
      background: linear-gradient(177deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 3px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 21px;
      color: #eb3f25;
      line-height: 27px;
      text-align: center;
      font-style: normal;
    }
  }

  .icon_miao {
    margin-right: 8px;
    display: block;
    width: 46px;
    height: 46px;
  }
}
</style>
